import React from "react";
import { NavLink } from "react-router-dom";

type AdminNavProps = {
  section?: "results" | "students" | "questions" | "imports" | "clipboard" | "cleanup";
};

const labels = {
  results: "\u0420\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u044b",
  students:
    "\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0441\u0442\u0443\u0434\u0435\u043d\u0442\u043e\u0432",
  questions: "\u0411\u0430\u0437\u044b",
  imports:
    "\u0418\u0441\u0442\u043e\u0440\u0438\u044f \u0432\u0435\u0434\u043e\u043c\u043e\u0441\u0442\u0435\u0439",
  clipboard:
    "\u0412\u0441\u0442\u0430\u0432\u043a\u0438 \u0431\u043e\u0442\u0430",
  cleanup:
    "\u042d\u043a\u0437\u0430\u043c\u0435\u043d\u0430\u0446\u0438\u043e\u043d\u043d\u0430\u044f \u0441\u0435\u0441\u0441\u0438\u044f",
};

const AdminNav: React.FC<AdminNavProps> = ({ section }) => {
  const role = localStorage.getItem("role");
  const isSuperadmin = role === "superadmin";
  const basePath = isSuperadmin ? "/superadmin" : "/admin";
  const className = section ? `admin-nav admin-nav-${section}` : "admin-nav";

  const links = isSuperadmin
    ? [
        { to: `${basePath}/results`, label: labels.results },
        { to: `${basePath}/students`, label: labels.students },
        { to: `${basePath}/questions`, label: labels.questions },
        { to: `${basePath}/imports`, label: labels.imports },
        { to: `${basePath}/bot-inserts`, label: labels.clipboard },
        { to: `${basePath}/cleanup`, label: labels.cleanup },
      ]
    : [
        { to: `${basePath}/students`, label: labels.students },
        { to: `${basePath}/questions`, label: labels.questions },
      ];

  return (
    <nav className={className}>
      {links.map((link) => (
        <NavLink key={link.to} to={link.to}>
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default AdminNav;
